import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../utils/api';

export default function AdminServiceForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const [form, setForm] = useState({ name: '', description: '', icon: '', sort_order: 0, is_active: true });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isEdit) {
      setLoading(false);
      return;
    }

    api.get('/admin/services')
      .then((res) => {
        const service = res.data.find((item) => String(item.id) === id);
        if (!service) return toast.error('Shërbimi nuk u gjet.');
        setForm({
          name: service.name || '',
          description: service.description || '',
          icon: service.icon || '',
          sort_order: service.sort_order || 0,
          is_active: service.is_active === 1 || service.is_active === true,
        });
      })
      .catch(() => toast.error('Gabim gjatë ngarkimit.'))
      .finally(() => setLoading(false));
  }, [id, isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = isEdit
        ? await api.put(`/admin/services/${id}`, form)
        : await api.post('/admin/services', form);
      toast.success(isEdit ? 'Shërbimi u përditësua.' : 'Shërbimi u krijua.');
      navigate('/admin/sherbimet');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Gabim.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <AdminLayout><div className="spinner" /></AdminLayout>;

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1 className="page-title">{isEdit ? 'Ndrysho Shërbimin' : 'Shërbim i Ri'}</h1>
        </div>
        <Link to="/admin/sherbimet" className="btn btn-secondary">← Kthehu</Link>
      </div>

      <div className="card" style={{ padding: '1.5rem' }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Emri *</label>
            <input
              className="form-input"
              value={form.name}
              required
              onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Përshkrimi</label>
            <textarea
              className="form-input"
              rows={4}
              value={form.description}
              onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Ikona</label>
            <input
              className="form-input"
              value={form.icon}
              onChange={(e) => setForm((p) => ({ ...p, icon: e.target.value }))}
            />
            <p style={{ fontSize: '0.72rem', color: 'var(--gray-400)', marginTop: 4 }}>
              Shtypni emrin e ikonës nëse doni një simbol, ose lëreni bosh.
            </p>
          </div>
          <div className="form-group">
            <label className="form-label">Renditja</label>
            <input
              className="form-input"
              type="number"
              value={form.sort_order}
              onChange={(e) => setForm((p) => ({ ...p, sort_order: Number(e.target.value) }))}
            />
          </div>
          <label className="form-label" style={{ display: 'block', marginBottom: '1rem' }}>
            <input
              type="checkbox"
              checked={form.is_active}
              onChange={(e) => setForm((p) => ({ ...p, is_active: e.target.checked }))}
              style={{ marginRight: '0.5rem' }}
            />
            Aktiv
          </label>

          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Duke ruajtur...' : isEdit ? 'Ruaj ndryshimet' : 'Krijo shërbim'}
          </button>
        </form>
      </div>
    </AdminLayout>
  );
}
